import { useEffect } from "react";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const UPDATE_QUERY_KEY = "_appVersion";
const UPDATE_ATTEMPT_KEY = "iyzishipUpdateAttempt";

const VersionChecker = () => {
  useEffect(() => {
    const currentVersion = process.env.REACT_APP_BUILD_VERSION;

    if (!currentVersion) return undefined;

    let isChecking = false;

    const checkVersion = async () => {
      if (isChecking) return;
      isChecking = true;

      try {
        const publicUrl = process.env.PUBLIC_URL || "";
        const response = await fetch(`${publicUrl}/version.json?t=${Date.now()}`, {
          cache: "no-store",
          headers: {
            "Cache-Control": "no-cache",
          },
        });

        if (!response.ok) return;

        const { version: latestVersion } = await response.json();

        if (!latestVersion) return;

        if (latestVersion === currentVersion) {
          sessionStorage.removeItem(UPDATE_ATTEMPT_KEY);

          const currentUrl = new URL(window.location.href);
          if (currentUrl.searchParams.has(UPDATE_QUERY_KEY)) {
            currentUrl.searchParams.delete(UPDATE_QUERY_KEY);
            window.history.replaceState(null, "", currentUrl.toString());
          }
          return;
        }

        if (sessionStorage.getItem(UPDATE_ATTEMPT_KEY) === latestVersion) return;

        sessionStorage.setItem(UPDATE_ATTEMPT_KEY, latestVersion);

        const updateUrl = new URL(window.location.href);
        updateUrl.searchParams.set(UPDATE_QUERY_KEY, latestVersion);
        window.location.replace(updateUrl.toString());
      } catch (error) {
        console.warn("Uygulama sürümü kontrol edilemedi:", error);
      } finally {
        isChecking = false;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") checkVersion();
    };

    checkVersion();
    const intervalId = window.setInterval(checkVersion, CHECK_INTERVAL_MS);
    window.addEventListener("focus", checkVersion);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", checkVersion);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null;
};

export default VersionChecker;
